/**
 * Created by alex.y on 9/26/2017.
 */
export enum ReportType{
    TotalFee = 0,
    TotalQuantity = 1
}


// WEBPACK FOOTER //
// ./app/objects/report/reportType.ts